export default function setFileURL (fileName, type = 'image') {

    let rootDir = '';

    if (type === 'image') rootDir = '/notifications/images/'
    return process.env.VUE_APP_FILES_BASE_URL + rootDir + fileName
}
